/* Galerías que rotan una plaza cada 2,5 s: el #lireayou de la home y los
   tonos de la ficha. Se mueve la fila entera y, al acabar la transición, la
   primera foto se recoloca al final. Bucle infinito sin duplicar nodos. */
(function () {
  var PAUSA = 2500, DURACION = 650;
  var SELECTOR = '[id$="__tonos"] .multicolumn-list, [id$="__tonos_ficha"] .multicolumn-list';

  function rotar(lista) {
    if (!lista || lista.children.length < 2) return;

    var parado = false;
    lista.addEventListener('mouseenter', function () { parado = true; });
    lista.addEventListener('mouseleave', function () { parado = false; });

    setInterval(function () {
      if (parado || document.hidden) return;
      var primera = lista.firstElementChild;
      var salto = primera.getBoundingClientRect().width +
                  parseFloat(getComputedStyle(lista).columnGap || 0);
      lista.style.transition = 'transform ' + DURACION + 'ms cubic-bezier(.33,0,.2,1)';
      lista.style.transform = 'translateX(-' + salto + 'px)';
      setTimeout(function () {
        lista.style.transition = 'none';
        lista.style.transform = 'translateX(0)';
        lista.appendChild(primera);
        void lista.offsetWidth;            // repintado antes de reactivar la transición
      }, DURACION);
    }, PAUSA);
  }

  function arrancar() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    Array.prototype.forEach.call(document.querySelectorAll(SELECTOR), rotar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
})();

/* tarjetas de dato seleccionables */
(function () {
  document.addEventListener('click', function (ev) {
    var tarjeta = ev.target.closest && ev.target.closest('.lirea-comp__dato');
    if (!tarjeta) return;
    var grupo = tarjeta.parentElement.querySelectorAll('.lirea-comp__dato');
    Array.prototype.forEach.call(grupo, function (t) { t.classList.remove('is-active'); });
    tarjeta.classList.add('is-active');
  });
})();

/* ── Suplemento de protección de envío (01/09) ────────────────────────────
   El interruptor vive pegado al botón de pagar, en las dos pantallas: el cajón
   lateral y /cart. Se escucha en document porque el tema reemplaza el HTML del
   carrito entero en cada cambio, así que un listener pegado al input se perdería
   en el primer clic.

   🔑 Los ids de sección NO se escriben a mano. En una plantilla JSON el id real
   es `template--<id>__<clave>` (aquí `template--29759761514880__cart-footer`),
   no `cart-footer`: pedir "cart-footer" a la Section Rendering API devuelve una
   cadena VACÍA, sin error. Mismo tropiezo que el 30/08. Se leen del DOM. */
(function () {
  var trabajando = false;

  // ids de las secciones que hay que repintar, tal y como están en esta página
  function seccionesDeAqui() {
    var ids = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
      if (el.querySelector('#main-cart-items, #main-cart-footer, cart-drawer') ||
          el.matches('#shopify-section-cart-drawer')) {
        ids.push(el.id.replace('shopify-section-', ''));
      }
    });
    if (ids.indexOf('cart-icon-bubble') < 0) ids.push('cart-icon-bubble');
    return ids;
  }

  function repintar(estado) {
    if (!estado || !estado.sections) return false;
    var cajon = document.querySelector('cart-drawer');
    var enPaginaCarrito = !!document.getElementById('main-cart-footer');

    // en el cajón lateral manda el propio tema: sabe reabrirlo y reengancharlo
    if (!enPaginaCarrito && cajon && estado.sections['cart-drawer'] &&
        typeof cajon.renderContents === 'function') {
      cajon.renderContents(estado);
      return true;
    }

    var pintadas = 0;
    Object.keys(estado.sections).forEach(function (id) {
      var destino = document.getElementById('shopify-section-' + id);
      var html = estado.sections[id];
      if (!destino || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var envuelto = doc.getElementById('shopify-section-' + id);
      destino.innerHTML = envuelto ? envuelto.innerHTML : (doc.body ? doc.body.innerHTML : html);
      pintadas++;
    });
    return pintadas > 0;
  }

  document.addEventListener('change', function (e) {
    var chk = e.target;
    if (!chk.classList || !chk.classList.contains('lirea-prot__check')) return;

    var caja = chk.closest('.lirea-prot');
    var id = caja && caja.dataset.variante;
    if (!id) return;

    if (trabajando) { chk.checked = !chk.checked; return; }
    trabajando = true;
    caja.classList.add('lirea-prot--cargando');

    var quiere = chk.checked;
    var secciones = seccionesDeAqui();
    var url = quiere ? '/cart/add.js' : '/cart/change.js';
    var cuerpo = quiere
      ? { items: [{ id: Number(id), quantity: 1 }], sections: secciones, sections_url: window.location.pathname }
      : { id: String(id), quantity: 0, sections: secciones, sections_url: window.location.pathname };

    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cuerpo),
    })
      .then(function (r) { return r.json(); })
      .then(function (estado) {
        if (!repintar(estado)) window.location.reload();
      })
      .catch(function () {
        chk.checked = !quiere;        // que la casilla no mienta si falló
      })
      .finally(function () {
        trabajando = false;
        var c = document.querySelector('.lirea-prot');
        if (c) c.classList.remove('lirea-prot--cargando');
      });
  });
})();


/* ── Carrito huérfano: la protección sola no es un carrito (06/09) ─────────
   La protección se oculta del listado (etiqueta 'add-on') y su interruptor solo
   se pinta si hay otros artículos. Al borrar el último labial se quedaba dentro:
   invisible, imposible de quitar a mano, contando en el icono y COBRABLE en el
   checkout — un pedido de solo protección y ningún producto.
   Aquí se detecta y se vacía. Los complementos se reconocen por 'handle', que es
   lo que devuelve /cart.js; las etiquetas del producto no vienen ahí. */
(function () {
  var COMPLEMENTOS = ['proteccion-de-envio'];

  function esComplemento(item) {
    return COMPLEMENTOS.indexOf(item.handle) >= 0;
  }

  function limpiar() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        if (!carrito || !carrito.items || !carrito.items.length) return;
        var soloComplementos = carrito.items.every(esComplemento);
        if (!soloComplementos) return;
        return fetch('/cart/clear.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        }).then(function () { window.location.reload(); });
      })
      .catch(function () { /* si falla, el carrito se queda como estaba */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', limpiar);
  } else {
    limpiar();
  }

  // Al quitar el último artículo el tema repinta el carrito sin recargar la página,
  // así que hay que volver a mirar después de ese clic.
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('cart-remove-button, .cart-remove-button, [id^="Remove-"], [href*="/cart/change"]')) {
      setTimeout(limpiar, 900);
    }
  }, true);
})();


/* ── Protección automática, con memoria del «no» (06/09) ───────────────────
   Se añade sola en cuanto hay un producto en el carrito, porque marcada por
   defecto convierte mucho más que esperando a que alguien la marque. Pero si la
   clienta la quita, NO vuelve: reponer un cargo que alguien acaba de rechazar es
   un patrón oscuro y acaba en disputa. La decisión se recuerda en localStorage.
   Hermano del bloque de arriba: allí se vacía el carrito que solo tiene
   protección; aquí se añade cuando hay algo que proteger. La protección
   acompaña a un pedido, nunca ES un pedido. */
(function () {
  var COMPLEMENTOS = ['proteccion-de-envio'];
  var CLAVE = 'lirea:proteccion-rechazada';
  var trabajando = false;

  function rechazada() {
    try { return localStorage.getItem(CLAVE) === '1'; } catch (e) { return false; }
  }
  function recordarRechazo(si) {
    try { si ? localStorage.setItem(CLAVE, '1') : localStorage.removeItem(CLAVE); } catch (e) {}
  }

  // El interruptor manual manda: al desmarcarlo se recuerda, al marcarlo se olvida.
  document.addEventListener('change', function (e) {
    var chk = e.target;
    if (chk.classList && chk.classList.contains('lirea-prot__check')) recordarRechazo(!chk.checked);
  });

  function seccionesDeAqui() {
    var ids = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
      if (el.querySelector('#main-cart-items, #main-cart-footer, cart-drawer') ||
          el.matches('#shopify-section-cart-drawer')) {
        ids.push(el.id.replace('shopify-section-', ''));
      }
    });
    if (ids.indexOf('cart-icon-bubble') < 0) ids.push('cart-icon-bubble');
    return ids;
  }

  function repintar(estado) {
    if (!estado || !estado.sections) return;
    var cajon = document.querySelector('cart-drawer');
    if (!document.getElementById('main-cart-footer') && cajon &&
        estado.sections['cart-drawer'] && typeof cajon.renderContents === 'function') {
      cajon.renderContents(estado);
      return;
    }
    Object.keys(estado.sections).forEach(function (id) {
      var destino = document.getElementById('shopify-section-' + id);
      var html = estado.sections[id];
      if (!destino || !html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var env = doc.getElementById('shopify-section-' + id);
      destino.innerHTML = env ? env.innerHTML : (doc.body ? doc.body.innerHTML : html);
    });
  }

  function idProteccion() {
    var caja = document.querySelector('.lirea-prot');
    return caja && caja.dataset.variante ? Number(caja.dataset.variante) : null;
  }

  function auto() {
    if (trabajando || rechazada()) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (carrito) {
        if (!carrito || !carrito.items || !carrito.items.length) return;
        var reales = 0, yaEsta = false;
        carrito.items.forEach(function (it) {
          if (COMPLEMENTOS.indexOf(it.handle) >= 0) yaEsta = true; else reales++;
        });
        if (!reales || yaEsta) return;

        var id = idProteccion();
        if (!id) return;   // el interruptor no está pintado en esta pantalla: se hará en la siguiente

        trabajando = true;
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: id, quantity: 1 }],
            sections: seccionesDeAqui(),
            sections_url: window.location.pathname,
          }),
        })
          .then(function (r) { return r.json(); })
          .then(repintar)
          .finally(function () { trabajando = false; });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auto);
  else auto();

  // Tras añadir al carrito el tema repinta sin recargar, así que hay que volver a mirar.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.action && f.action.indexOf('/cart/add') >= 0) setTimeout(auto, 1200);
  }, true);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[name="add"], .product-form__submit')) setTimeout(auto, 1400);
  }, true);
})();


/* ── Cookies · plegar el texto con «Ver más» (06/09) ───────────────────────
   El párrafo de Shopify ocupaba media pantalla en el móvil. Se pliega a tres
   líneas y se despliega con un clic. El texto NO se toca: lo inyecta el JS de
   Shopify y no es editable desde el tema — plegarlo es lo único que está en
   nuestra mano, y deja la información íntegra a un clic. */
(function () {
  var VISTO = 'lireaCookiesPlegado';

  function plegar(banner) {
    var p = banner.querySelector('.shopify-pc__banner__dialog p');
    if (!p || p.dataset.plegado) return;
    p.dataset.plegado = '1';
    p.classList.add('lirea-cookie-txt', 'is-plegado');

    var boton = document.createElement('button');
    boton.type = 'button';
    boton.className = 'lirea-cookie-vermas';
    boton.textContent = 'Ver más';
    boton.setAttribute('aria-expanded', 'false');
    p.insertAdjacentElement('afterend', boton);

    boton.addEventListener('click', function () {
      var abierto = p.classList.toggle('is-plegado') === false;
      boton.textContent = abierto ? 'Ver menos' : 'Ver más';
      boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });

    // Si el texto cabe entero, el botón sobra.
    if (p.scrollHeight <= p.clientHeight + 2) boton.remove();
  }

  function mirar() {
    var b = document.getElementById('shopify-pc__banner');
    if (b && !b.dataset[VISTO]) { b.dataset[VISTO] = '1'; plegar(b); }
  }

  mirar();
  document.addEventListener('DOMContentLoaded', mirar);
  // El banner lo inyecta Shopify cuando le toca, no al cargar la página.
  if (window.MutationObserver) {
    new MutationObserver(mirar).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
